import React from 'react';
import { notification, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { Content } from 'antd/lib/layout/layout';

import { useAppDispatch, useAppSelector } from 'store';
import { MainLayout } from 'components/Layout/MainLayout';
import { useQuery } from 'hooks/useQuery';
import { useDeepEffect } from 'utils/useDeepEffect';
import { StickyConfirmModal } from 'components/modals/StickyConfirmModal';
import { PageTitles } from 'constants/pageTitles';
import {
  deleteReviewsItem,
  loadReviewsList,
  updateStatusItem,
} from 'store/slices/reviews/actions';
import { IReviewsItemResponse } from 'store/slices/reviews/interfaces';
import { canBeUnPublished } from 'utils/rights';
import { StatusesEnum } from 'constants/status';

import { Filters } from './components/Filters';
import { ListTable } from './components/ListTable';

export const SYMBOL_LIMIT = 40;

export const List = () => {
  const [sort, setSort] = React.useState(null);
  const dispatch = useAppDispatch();
  const query = useQuery();
  const { list, total, limit } = useAppSelector(state => state.reviews);

  const loadReviews = () => {
    dispatch(
      loadReviewsList({
        ...query,
        sort: '-createdAt',
      })
    );
  };

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [currentItem, setCurrentItem] =
    React.useState<IReviewsItemResponse | null>(null);
  useDeepEffect(() => {
    loadReviews();
  }, [query, sort]);

  const modalCloseHandler = () => {
    setModalIsOpen(false);
    setCurrentItem(null);
  };
  const handleUnPublish = async id => {
    await dispatch(updateStatusItem({ id, status: StatusesEnum.NOT_PUBLISHED }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Отзыв успешно снят с публикации',
        });

        modalCloseHandler();
        loadReviews();
      });
  };

  const handleRemove = async id => {
    await dispatch(deleteReviewsItem(id))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Отзыв успешно удален',
        });
        loadReviews();
        modalCloseHandler();
      });
  };

  const getActions = item => [
    {
      key: 'edit',
      label: <Link to={`/reviews/${item.id}/edit`}>Редактировать</Link>,
    },
    canBeUnPublished(item) && {
      key: 'unPublish',
      label: <Typography.Text>Снять с публикации</Typography.Text>,
      onClick: () => handleUnPublish(item?.id || 0),
    },
    {
      key: 'delete',
      label: <Typography.Text type='danger'>Удалить</Typography.Text>,
      onClick: () => {
        setModalIsOpen(true);
        setCurrentItem(item);
      },
    },
  ];

  return (
    <MainLayout pageTitle={PageTitles.reviews} aside={<Filters />}>
      <Content>
        <ListTable
          data={list}
          total={total}
          getActions={getActions}
          limit={limit}
          setSort={setSort}
        />
      </Content>
      {currentItem?.id && (
        <>
          {modalIsOpen && (
            <StickyConfirmModal
              isOpen={modalIsOpen}
              onRequestClose={modalCloseHandler}
              title='Удаление отзыва'
              okText='Удалить'
              text={
                <div>
                  Вы хотите удалить отзыв на{' '}
                  <Typography.Text strong>
                    {currentItem.entityInfo.name}
                  </Typography.Text>
                  ?
                </div>
              }
              onSubmit={() => handleRemove(currentItem?.id)}
              okButtonProps={{ danger: true }}
            />
          )}
        </>
      )}
    </MainLayout>
  );
};
